<template>
  <div class="edit-modal-wrap">
    <el-dialog
      :title="modalTitle"
      :visible.sync="dialogVisible"
      width="488px"
      @closed="modalClosed"
      @open="initSelect"
    >
      <div class="modal-body">
        <div class="form-content">
          <el-form :rules="rules" ref="formRef" :model="formData" label-width="115px">
            <el-form-item label="转化追踪方式 :">
              <el-radio-group v-model="formData.convert_source_type">
                <el-radio label="AD_CONVERT_SOURCE_TYPE_APP_DOWNLOAD" :disabled="isEdit"
                  >应用下载API</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="account_id">
              <span slot="label"> <span style="color: red">*</span> 广告账号 :</span>
              <el-select
                :disabled="isEdit"
                style="width: 100%"
                v-model="formData.account_id"
                filterable
              >
                <el-option
                  v-for="item of countList"
                  :key="item.advertiserId"
                  :value="item.advertiserId"
                  :label="item.company + '-' + item.advertiserName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="app_name">
              <span slot="label"> <span style="color: red">*</span> 应用名称 :</span>
              <el-select
                :disabled="isEdit"
                style="width: 100%"
                v-model="formData.app_name"
                @change="fillPackageData"
                filterable
              >
                <el-option
                  v-for="item of appList"
                  :key="item.app_cloud_id"
                  :value="item.app_name"
                  :label="item.app_name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="package_name">
              <span slot="label"> <span style="color: red">*</span> 应用包名 :</span>
              <el-input
                :disabled="isEdit"
                v-model="formData.package_name"
                placeholder="请输入包名"
                maxlength="25"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item prop="name">
              <span slot="label"> <span style="color: red">*</span> 转化名称 :</span>
              <el-input
                :disabled="isEdit"
                v-model="formData.name"
                placeholder="请输入转化名称"
                maxlength="25"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item prop="download_url">
              <span slot="label"> <span style="color: red">*</span> 下载链接 :</span>
              <el-input
                :disabled="isEdit"
                v-model="formData.download_url"
                placeholder="请输入下载链接"
              ></el-input>
            </el-form-item>
            <el-form-item prop="convert_type">
              <span slot="label"> <span style="color: red">*</span> 转化目标 :</span>
              <el-select :disabled="isEdit" style="width: 100%" v-model="formData.convert_type">
                <el-option value="AD_CONVERT_TYPE_ACTIVE" label="激活"></el-option>
                <el-option value="AD_CONVERT_TYPE_BEHAVIOR" label="行为"></el-option>
                <el-option value="AD_CONVERT_TYPE_GAME_ADDICTION" label="关键行为"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="deep_external_action">
              <span slot="label"> <span style="color: red">*</span> 深度转化目标 :</span>
              <el-select
                :disabled="isEdit"
                style="width: 100%"
                v-model="formData.deep_external_action"
              >
                <el-option value="0" label="无"></el-option>
                <el-option value="7" label="次日留存"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="action_track_url">
              <span slot="label"> <span style="color: red">*</span> 点击监测链接 :</span>
              <el-input
                :disabled="isEdit"
                v-model="formData.action_track_url"
                placeholder="请输入点击监测链接"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label"> 展示监测链接 :</span>
              <el-input
                :disabled="isEdit"
                v-model="formData.display_track_url"
                placeholder="请输入展示监测链接"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="footer-wrap">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button @click="submitData" type="primary" v-show="!isEdit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCommonProductList } from "@/api/api.js";
import { getAdCount, createConvert } from "@/api/property.js";
export default {
  data() {
    return {
      isEdit: false,
      dialogVisible: false,
      modalTitle: "转化详情",
      countList: [],
      appList: [],
      formData: {
        convert_source_type: "AD_CONVERT_SOURCE_TYPE_APP_DOWNLOAD",
        account_id: null,
        app_name: "",
        package_name: "",
        name: "",
        download_url: "",
        convert_type: null,
        deep_external_action: null,
        action_track_url: "",
        display_track_url: "",
      },
      rules: {
        account_id: [{ required: true, message: "请选择广告账号", trigger: "change" }],
        app_name: [{ required: true, message: "请输入应用名称", trigger: "change" }],
        package_name: [{ required: true, message: "请输入包名", trigger: "change" }],
        name: [{ required: true, message: "请输入转化名称", trigger: "change" }],
        download_url: [
          { required: true, message: "请输入下载链接", trigger: "change" },
          { validator: this.linkCheck, trigger: "blur" },
        ],
        convert_type: [{ required: true, message: "请输入转化目标", trigger: "change" }],
        deep_external_action: [
          { required: true, message: "请输入深度转化目标", trigger: "change" },
        ],
        action_track_url: [
          { required: true, message: "请输入点击监测链接", trigger: "change" },
          { validator: this.linkCheck, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    addTransform() {
      this.isEdit = false;
      this.dialogVisible = true;
    },
    checkTransform(data) {
      this.formData.convert_source_type = data.convert_source_type;
      this.formData.account_id = data.account_id;
      this.formData.app_name = data.app_name;
      this.formData.package_name = data.package_name;
      this.formData.name = data.name;
      this.formData.download_url = data.download_url;
      this.formData.convert_type = data.convert_type;
      this.formData.deep_external_action = data.deep_external_action
        ? data.deep_external_action
        : "NONE";
      this.formData.action_track_url = data.action_track_url;
      this.formData.display_track_url = data.display_track_url;
      this.isEdit = true;
      this.dialogVisible = true;
    },
    initSelect() {
      getAdCount().then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
        }
      });
      getCommonProductList({
        platType: 3,
      }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
    },
    fillPackageData(appName) {
      let app = this.appList.find((item) => item.app_name === appName);
      if (app) {
        this.formData.package_name = app.package_name;
      }
    },
    submitData() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          createConvert(this.formData).then((res) => {
            if (res.code === "0000") {
              this.dialogVisible = false;
              this.$message({
                message: "新增应用转化成功",
                type: "success",
              });
              this.$emit("refreshList");
            }
          });
        }
      });
    },
    modalClosed() {
      this.$refs.formRef.resetFields();
    },
    linkCheck(rule, value, callback) {
      if (!/^https:\/\/.+\..+/.test(value)) {
        callback(new Error("请输入正确的https协议链接"));
      } else {
        callback();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal-body {
  .form-content {
    /deep/ .el-radio__input.is-checked .el-radio__inner {
      color: rgba(24, 144, 255, 1);
      border-color: rgba(24, 144, 255, 1);
      background: rgba(24, 144, 255, 1);
    }
    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: rgba(24, 144, 255, 1);
    }
  }
  .footer-wrap {
    text-align: right;
    padding-bottom: 24px;
  }
}
</style>
